import React from 'react';

function withFilter(objectStore, filters, applyFilter) {
  return FilteredContainer => (
    class Container extends React.Component {
      constructor(props) {
        super(props);
        this.state = {
          rawObjects: objectStore.getForFilter(),
          filters,
        };

        this._onChange = this._onChange.bind(this);
        this.updateFilter = this.updateFilter.bind(this);
      }

      componentDidMount() {
        this.objectStoreSubscription = objectStore.addListener(this._onChange);
      }

      componentWillUnmount() {
        this.objectStoreSubscription.remove();
      }

      _onChange() {
        this.setState({ rawObjects: objectStore.getForFilter() });
      }

      filteredObjects() {
        return this.state.rawObjects.filter(applyFilter(this.state.filters));
      }

      updateFilter(key, value) {
        this.setState(prevState => ({ filters: prevState.filters.set(key, value) }));
      }

      render() {
        const newProps = {
          filters: this.state.filters,
          updateFilter: this.updateFilter,
          filteredObjects: this.filteredObjects(),
        };

        return <FilteredContainer {...this.props} {...newProps} />;
      }
    }
  );
}

export default withFilter;
